import _ from 'lodash';
import { navigate } from 'raviger';
import React, { Suspense, useEffect, useState } from 'react';
import { Panel } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Permission from '../../components/Permission/Permission';
import Spinner from '../../components/Spinner/Spinner';
import * as constants from '../../constants';
import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import { useAlertStore } from '../../store/providers/Alert';
import { useSurveyTemplatesStore } from '../../store/providers/SurveyTemplates';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const SurveyTemplateForm = React.lazy(() => import('./SurveyTemplateForm'));

function SurveyTemplate(props) {
    const dispatch = useDispatch();
    const { addAlert } = useAlertStore();
    const { selectRecord, newRecord, data, clearData } = useSurveyTemplatesStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [title, setTitle] = useState('');
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const pagePermission = constants.PERMISSION_CONTENT_SURVEYTEMPLATES;

    const cancelledHandler = (e) => {
        navigate('/surveyTemplates');
    };

    const submittedHandler = (e) => {
        navigate('/surveyTemplates');
    };

    useEffect(() => {
        if (!_.isEmpty(data)) {
            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (!isLoaded && isMounted && data.scope === 'select' && data.status === 'success') {
                setTitle(`Edit Survey Template (Id: ${data.body.template.id})`);
                setIsLoaded(true);
                dispatch(breadcrumbAddRoute({ key: 'edit-surveyTemplate', text: 'Edit Survey Template' }));
            }

            if (!isNew && (data.scope === 'new' && data.status === 'success')) {
                setTitle(`New Survey Template`);
                setIsLoaded(true);
                setIsNew(true);
                dispatch(breadcrumbAddRoute({ key: 'new-surveyTemplate', text: 'New Survey Template' }));
            }
        }
    }, [props, data, addAlert, clearData, isLoaded, isMounted, isNew, dispatch]);

    useEffect(() => {
        if (hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'surveyTemplates', parent: 'Content', text: 'Survey Templates', path: '/surveyTemplate' }));

        if (!_.isEmpty(props.surveyTemplateId)) {
            selectRecord({ id: props.surveyTemplateId });
        } else {
            newRecord();
        }

        setIsMounted(true);
    }, [isMounted, hasPermission, dispatch, newRecord, props.surveyTemplateId, selectRecord]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    return (
        <>
            <SideMenu activeKey="content" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>
                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title={title} />
                            <Panel>
                                <Panel.Body>
                                    <SurveyTemplateForm
                                        canEdit={canEdit}
                                        surveyTemplateId={props.surveyTemplateId}
                                        submitted={() => submittedHandler()}
                                        cancelled={() => cancelledHandler()} />
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );
}

export default withAuthentication(withLayout(SurveyTemplate));